/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import type {
  AppPreviewGalleryButtonDisplayState,
  AppPreviewGalleryButtonDisplaySlots,
} from "./AppPreviewGalleryButtonDisplay.types";
import { renderPreviewButtons } from "./renderPreviewButtons";
import { assertSlots } from "@fluentui/react-components";
import { TransitionGroup } from "react-transition-group";

export const renderAppPreviewGalleryButtonDisplay = (
  state: AppPreviewGalleryButtonDisplayState
) => {
  const { stack, animate } = state;
  const shouldRenderAsStack = !!stack;

  assertSlots<AppPreviewGalleryButtonDisplaySlots>(state);

  const previewButtons: JSX.Element[] = renderPreviewButtons(state);
  const buttons: JSX.Element | JSX.Element[] = !!animate ? (
    <TransitionGroup component={null}>{previewButtons}</TransitionGroup>
  ) : (
    previewButtons
  );

  return (
    <state.root>
      {shouldRenderAsStack ? (
        <state.stackWrapper>{buttons}</state.stackWrapper>
      ) : (
        buttons
      )}
    </state.root>
  );
};
